import './index.less'

export default class PhotovolaticCommentList {
  constructor({ pcEl, mbEl, }) {
    this.PCDOM = document.querySelector(pcEl)
    this.MBDOM = document.querySelector(mbEl)
    this.pcEl = pcEl
    this.mbEl = mbEl

    if (this.PCDOM && this.MBDOM) {
      const { size, } = this.PCDOM.dataset
      this.size = size

      this.init()

      this.init = this.init.bind(this)
      window.addEventListener('resize', this.init)
    }
  }
  init() {
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
    if (clientWidth < 1024) {
      this.MBDOM.classList.remove('hidden')
      this.PCDOM.classList.add('hidden')

      if (this.size <= 1) {
        this.registerClickEvent(this.MBDOM)
      }

      if (!this.swiperMB && this.size > 1) {
        this.MBDOM && this.initMB();
      }

      // resize 时清除
      this.swiperPC?.destroy();
      this.swiperPC = null;
    } else {
      this.MBDOM.classList.add('hidden')
      this.PCDOM.classList.remove('hidden')

      if (this.size <= 5) {
        this.registerClickEvent(this.PCDOM)
      }

      if (!this.swiperPC && this.size > 5) {
        this.PCDOM && this.initPC();
      }

      // resize 时清除
      this.swiperMB?.destroy();
      this.swiperMB = null;
    }
  }
  initPC() {
    const self = this
    this.swiperPC = new Swiper(this.pcEl, {
      slidesPerView: 5,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: '.swiper-commentlist-pc-button-next',
        prevEl: '.swiper-commentlist-pc-button-prev',
      },
      on: {
        init: function() {
          self.registerClickEvent(self.PCDOM)
        }
      }
    });
  }
  renderMediaDom({ commentProfile, headerName, authTitle, issueTime, seeMore, description, commentLink, likes, comment, imageOne, imageTwo, imageThree, imageFour,imageFive,imageSix }) {
    const images = [imageOne, imageTwo, imageThree, imageFour, imageFive, imageSix].filter(image => Boolean(image) && !image.endsWith('4c.gif'));
    const imageCount = images.length;
    let imageHtml = '';
    // Generate the appropriate HTML based on the number of images
    if (imageCount === 1) {
      imageHtml = `<img src="${images[0]}" alt="Comment Image 1" class="comment-list-image one">`;
    } else if (imageCount === 2) {
      imageHtml = `
        <div class="two-images">
            <img src="${images[0]}" alt="Comment Image 1" class="comment-list-image two">
            <img src="${images[1]}" alt="Comment Image 2" class="comment-list-image two">
        </div>`;
    } else if (imageCount === 3) {
      imageHtml = `
        <div class="one-large-two-small">
            <img src="${images[0]}" alt="Comment Image 1" class="comment-list-image three large">
            <div class="two-small">
                <img src="${images[1]}" alt="Comment Image 2" class="comment-list-image three small">
                <img src="${images[2]}" alt="Comment Image 3" class="comment-list-image three small">
            </div>
        </div>`;
    } else if (imageCount === 4) {
      imageHtml = `
        <div class="two-small-two-small">
            <img src="${images[0]}" alt="Comment Image 1" class="comment-list-image four small">
            <img src="${images[1]}" alt="Comment Image 2" class="comment-list-image four small">
            <img src="${images[2]}" alt="Comment Image 3" class="comment-list-image four small">
            <img src="${images[3]}" alt="Comment Image 4" class="comment-list-image four small">
        </div>`;
    } else if (imageCount === 5) {
      imageHtml = `
        <div class="two-large-three-small">
            <div class="two-large">
                <img src="${images[0]}" alt="Comment Image 1" class="comment-list-image five large">
                <img src="${images[1]}" alt="Comment Image 2" class="comment-list-image five large">
            </div>
            <div class="three-small">
                <img src="${images[2]}" alt="Comment Image 3" class="comment-list-image five small">
                <img src="${images[3]}" alt="Comment Image 4" class="comment-list-image five small">
                <img src="${images[4]}" alt="Comment Image 5" class="comment-list-image five small">
            </div>
        </div>`;
    } else if (imageCount === 6) {
      imageHtml = `
        <div class="two-small-two-small">
            <img src="${images[0]}" alt="Comment Image 1" class="comment-list-image four small">
            <img src="${images[1]}" alt="Comment Image 2" class="comment-list-image four small">
            <img src="${images[2]}" alt="Comment Image 3" class="comment-list-image four small">
            <img src="${images[3]}" alt="Comment Image 4" class="comment-list-image four small">
            <img src="${images[4]}" alt="Comment Image 5" class="comment-list-image four small">
            <img src="${images[5]}" alt="Comment Image 6" class="comment-list-image four small">
        </div>`;
    }
    let commentDom = `
        <div class="comment-detail">
            <a href="${commentLink}" target="_blank" style="color:unset;">
              <div class="comment-top">
                  <div class="comment-header"><img style="border-radius: 50%" src="${commentProfile}" alt="header image"></div>
                  <div class="comment-name">
                      <div class="name-title">${headerName}</div>
                      <div class="name-auth">
                        <div class="auth-title ${authTitle ? '' : 'hidden'}">${authTitle}</div>
                        <div class="name-time">${issueTime}</div>
                      </div>
                  </div>
              </div>
            </a>
            <div class="comment-body">
                <div class="comment-description">
                  <div class="comment-text">${description}</div>
                  <div class="see-more ${description ? '' : 'hidden'}">${seeMore}</div>
                </div>
                <div class="comment-all-image">
                    <a href="${commentLink}" target="_blank" style="color:unset;">
                       ${imageHtml}
                    </a>
                </div>
            </div>
            <div class="comment-bottom">
                <div class="comment-bottom-left">
                    <span class="like-icon ${likes ? '' : 'hidden'}"><svg width="" height="" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.0677" cy="11.4934" r="10.802" fill="url(#paint0_linear_3476_425)"/>
                        <path d="M12.8356 9.17605C13.5432 9.17605 14.2272 9.21397 14.9059 9.16847C16.384 9.06837 17.6383 10.1907 17.2485 11.9714C17.0301 12.9678 16.8936 13.9818 16.7184 14.9873C16.5516 15.9467 15.7917 16.6944 14.799 16.7316C12.8591 16.8044 10.9412 16.655 9.10147 15.9474C8.81329 15.8367 8.73215 15.6926 8.73442 15.3953C8.74807 13.4873 8.74655 11.5785 8.73518 9.66974C8.73366 9.41266 8.8277 9.26554 9.01805 9.10552C9.40253 8.78246 9.77716 8.44045 10.1124 8.06658C10.5219 7.6108 10.7024 7.05038 10.7168 6.43308C10.7236 6.13201 10.7448 5.82563 10.8108 5.53367C10.9056 5.11581 11.218 4.94442 11.6435 5.02784C12.5088 5.19772 13.142 5.96972 13.1556 6.90705C13.1609 7.28395 13.1367 7.66465 13.0836 8.03776C13.0313 8.40859 12.9259 8.77261 12.8356 9.17529V9.17605Z" fill="white"/>
                        <path d="M7.92887 12.7172C7.92887 13.6902 7.93115 14.6624 7.92811 15.6354C7.92584 16.239 7.56941 16.5985 6.96804 16.6053C6.55094 16.6099 6.13384 16.6144 5.71751 16.6038C5.21396 16.5909 4.82189 16.2201 4.81961 15.7173C4.80975 13.7091 4.81051 11.7003 4.81961 9.69137C4.82189 9.18707 5.20334 8.81244 5.7122 8.79348C6.15356 8.7768 6.59644 8.77755 7.03856 8.79348C7.5679 8.81244 7.92584 9.19086 7.92887 9.72323C7.93418 10.7212 7.93039 11.7192 7.93039 12.7172H7.92887Z" fill="white"/>
                        <defs>
                        <linearGradient id="paint0_linear_3476_425" x1="6.39242" y1="3.09766" x2="13.1711" y2="20.0445" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#53C3FC"/>
                        <stop offset="1" stop-color="#0A6BED"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </span>
                    <span class="like-num">${likes}</span>
                </div>
                <div class="comment-bottom-right">${comment}</div>
            </div>
        </div>
    `;

    return commentDom
  }
  initMB() {
    const self = this
    this.swiperMB = new Swiper(this.mbEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: '.swiper-commentlist-mb-button-next',
        prevEl: '.swiper-commentlist-mb-button-prev',
      },
      on: {
        init: function() {
          self.registerClickEvent(self.MBDOM)
        }
      }
    });
  }
  // 注册点击事件
  registerClickEvent(DOM) {
    DOM.querySelectorAll('.swiper-slide').forEach((item, index) => {
      item.onclick = () => {
        const { index, commentProfile, headerName, authTitle, issueTime, seeMore, description, commentLink, likes, comment, imageOne, imageTwo, imageThree, imageFour, imageFive, imageSix } = item.dataset
        const popupHtml = this.renderMediaDom({ commentProfile, headerName, authTitle, issueTime, seeMore, description, commentLink, likes, comment, imageOne, imageTwo, imageThree, imageFour, imageFive, imageSix })
        window.ZModle.getInstance(popupHtml, {
          id: `photovolatic-comment-list-popup-mb-${index}`,
          class: "photovolatic-comment-list-popup-warp",
          cb: (el) => {
            const $commentText = $(el).find('.comment-description .comment-text');
            const lineHeight = parseFloat($commentText.css('line-height'));
            const maxHeight = lineHeight * 4;
            if ($commentText[0].scrollHeight - 10 > maxHeight) {
              $(el).find('.see-more').show();
            } else {
              $(el).find('.see-more').hide();
            }
            $(el).find('.see-more').click(() => {
              $('.comment-description').each(function() {
                if ($(this).hasClass('expanded')) {
                  $(this).removeClass('expanded');
                } else {
                  $(this).addClass('expanded');
                }
              });
            })
          }
        })
      }
    })
  }
}
